import { Controller } from "@hotwired/stimulus"

// One instance per `.nested-fields.payment-select` row (see
// app/views/admin/invoices/_invoice_payment_fields.html.erb). Stimulus's
// connect() fires automatically as Cocoon inserts rows, so no manual
// `cocoon:after-insert` wiring is needed here.
export default class extends Controller {
  connect() {
    this.payVals = JSON.parse(this.element.dataset.payVals || "{}")

    this._onChange = this._onChange.bind(this)
    this.element.addEventListener("change", this._onChange)
  }

  disconnect() {
    this.element.removeEventListener("change", this._onChange)
  }

  _onChange(event) {
    const select = event.target
    if (select.tagName !== "SELECT" || !select.closest(".pay-item")) return

    const value = this.payVals[select.value]
    if (value === undefined) return

    const input = this.element.querySelector(".pay-val input")
    if (input) input.value = value
  }
}
